module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-sm-3\">\r\n        <span>Permissions</span>\r\n    </div>\r\n    <div class=\"col-sm-9\" style=\"padding-right: 0;\">\r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-sm-12\" style=\"padding: 0 0 0 7px;\">\r\n                 <div id=\"permissionsTable\"></div>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\" id=\"permissionsTableOperations\" style=\"display: none; padding-left:22px;\">\r\n                <button type=\"button\" title=\"Add new permission\" id=\"addPermission\" name=\"addPermission\"\r\n                    title=\"Add permission\" data-table-type=\"permissionsTable\"\r\n                    class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n                    <i class=\"fa pf-add\"></i>\r\n                </button>\r\n                <button type=\"button\" title=\"Remove selected permission\" title=\"Remove permission\" id=\"removePermission\"\r\n                    name=\"removePermission\" data-table-type=\"permissionsTable\"\r\n                    class=\"itemRemove btn btn-default hvr-glow tbl-icon\" disabled>\r\n                    <i class=\"fa pf-delete icon-gradient\"></i>\r\n                </button>\r\n    \r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}